/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { getEventName } from '@e180/domain/lib/event/util';

import { isSupported } from 'plugin/virtual-braindate/util/virtualBraindateUtils';

import IntroScreenDumb from './IntroScreenDumb';
import {
  getOnboardingCustomTitle,
  getOnboardingCustomSubtitle,
  getOnboardingCustomCTA,
} from 'plugin/onboarding-custom-text/util/onboardingCustomTextUtils';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import withFeatureDecisions from 'src/shared/app/feature/component/withFeatureDecisions';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  handleClick: () => void,
  // Self passed
  intl: intlShape,
  featureDecisions: Object,
};

const mapStateToProps = (
  state: State,
  { handleClick, intl, featureDecisions }: Props,
): Object => {
  const { locale } = intl;
  const event = getEventSafely(state);
  const isVideoCallEnabled = featureDecisions.isVideoCallEnabled();

  return {
    eventName: getEventName(event, locale),
    customTitle: getOnboardingCustomTitle(event, locale),
    customSubtitle: getOnboardingCustomSubtitle(event, locale),
    customCTA: getOnboardingCustomCTA(event, locale),
    handleClick,
    isVideoCallEnabled: featureDecisions.isVideoCallEnabled(),
    isVideoCallSupported: isVideoCallEnabled ? isSupported(event) : false,
  };
};

export default compose(
  injectIntl,
  withFeatureDecisions,
  connect(mapStateToProps),
)(IntroScreenDumb);
